module.exports = __webpack_public_path__ + "assets/img/nextRob.93e36a62.png";